import React, { useState } from 'react';
import ReactDom from 'react-dom';
import classnames from 'classnames';

const CookieConsent = () => {
  const [isOpen, setOpen] = useState(true);
  const handleCloseClick = () => setOpen(false);

  if (!localStorage.hasOwnProperty('cookieConsent'))
    localStorage.setItem('cookieConsent', true);

  return (
    <div
      className={classnames('cookie-consent', {
        'cookie-consent--visible': isOpen
      })}
    >
      <button className="cookie-consent__close" onClick={handleCloseClick}>
        <span className="u--visible-sr">Close</span>
      </button>
      <div className="cookie-consent__container container">
        <div className="cookie-consent__content">
          <h3 className="cookie-consent__title">We use cookies</h3>
          <p className="cookie-consent__copy">
            This website or its third-party tools uses cookies, which are
            necessary to its functioning and required to achieve the purposes
            illustrated in our{' '}
            <a href="/cookies-policy/" target="_blank">
              cookies policy
            </a>
            . By continuing to browse this website, you agree to the use of
            cookies.
          </p>
        </div>
        <button className="btn btn--red" onClick={handleCloseClick}>
          <span className="btn__content">
            <span className="btn__text">Ok</span>
          </span>
        </button>
      </div>
    </div>
  );
};

const appRoot = document.getElementById('cookie-consent');

window.addEventListener('DOMContentLoaded', () => {
  if (
    appRoot &&
    !localStorage.cookieConsent &&
    navigator.userAgent !== 'perc_bluetriangle_monitor'
  )
    ReactDom.render(<CookieConsent />, appRoot);
});
